import { initialState } from './reducer';
import { createSelector } from 'reselect';
import { NOTIFICATION_REDUCER_KEY } from './constants';

const subStateSelector = store => store[NOTIFICATION_REDUCER_KEY] || initialState;

export const getAllNotificationsSelector = createSelector(subStateSelector, state => state.all || initialState.all);
export const getPreviousQueryTimeSelector = createSelector(
  subStateSelector,
  state => state.queryTime || initialState.queryTime,
);

export const getNotifSelectedDeviceSelector = createSelector(subStateSelector, state => state.selectedDeviceIMEI || initialState.selectedDeviceIMEI);
export const getSelectedNotifIdSelector = createSelector(subStateSelector, state => state.selectedNotifId || initialState.selectedNotifId);
